import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";

export default function ProductionMetadataSection({
  isLoading,
  selectedProductionSystem,
  renderSection,
  loadingMessage = "Loading metadata. Please wait...",
  emptyStateText = "Select a production system to load relevant metadata."
}) {
  const shouldShowMetadata =
    selectedProductionSystem && selectedProductionSystem !== "Unknown";

  if (!shouldShowMetadata) {
    return null;
  }

  const content =
    typeof renderSection === "function"
      ? renderSection(selectedProductionSystem)
      : null;

  const showEmptyState = !isLoading && !content;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Production Metadata (optional)
      </Typography>
      {isLoading ? (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <CircularProgress size={18} />
          <Typography variant="body2">{loadingMessage}</Typography>
        </Stack>
      ) : null}
      <Box sx={{ display: isLoading ? "none" : "block" }}>{content}</Box>
      {showEmptyState ? (
        <Typography variant="body2" color="textSecondary">
          {emptyStateText}
        </Typography>
      ) : null}
    </Box>
  );
}
